import { render } from "./PhysicalInventory.vue?vue&type=template&id=2eb8edde"
import script from "./PhysicalInventory.vue?vue&type=script&lang=js"
export * from "./PhysicalInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PhysicalInventory/PhysicalInventory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2eb8edde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2eb8edde', __exports__)) {
    api.reload('2eb8edde', __exports__)
  }
  
  module.hot.accept("./PhysicalInventory.vue?vue&type=template&id=2eb8edde", () => {
    api.rerender('2eb8edde', render)
  })

}


export default __exports__